var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.teacherList.length)?_c('div',_vm._l((_vm.teacherList),function(item,index){return _c('div',{key:index,staticClass:"teacher-item clear"},[_c('div',{staticClass:"teacher-item__avatar",style:({
        backgroundImage: ("url(" + (item.avatar) + ")")
      })}),_c('div',{staticClass:"teacher-item__info"},[_c('p',{staticClass:"teacher-item__info__job-title"},[_vm._v("\n        "+_vm._s(item.typeName)+"\n      ")]),_c('p',{staticClass:"teacher-item__info__name"},[_vm._v("\n        "+_vm._s(item.name)+"\n      ")])])])}),0):_vm._e()}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-54e76cde","hasScoped":true,"preserveWhitespace":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/AddPurchase/components/teacher.vue
// module id = 1181
// module chunks = 1